<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="800px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { BlogCategory } from '@/modules/cms/data/blog-category/create'
	import { BlogCategoryService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return BlogCategory
			},
			service()
			{
				return new BlogCategoryService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>